/*
 * lightRouteFilters.js
 * Micro-factories for "light" index routes (no StatsGrid dependency).
 * Intent: eliminate duplicated Alpine filter/sort DOM loops while staying tiny.
 * Both factories are pure and return plain objects suitable for x-data spread.
 */

export function valueFilterState({ defaultValue = 'all', attr = 'data-status' } = {}) {
  return {
    selected: defaultValue,
    set(val) { this.selected = val; },
    // For x-show on wrapper elements holding cards
    shouldShow(el) {
      if (this.selected === 'all') return true;
      const v = el.getAttribute(attr) || el.dataset.playerStatus || el.dataset.country || '';
      return v === this.selected;
    }
  };
}

export function yearSortState({ containerId, dataAttr = 'year', initialSort = 'desc' }) {
  return {
    sortOrder: initialSort,
    selectedYear: 'all',
    setYear(y) { this.selectedYear = y; },
    setSort(order) { if (order !== this.sortOrder) { this.sortOrder = order; this.reorder(); } },
    reorder() {
      const container = document.getElementById(containerId);
      if (!container) return;
      const children = Array.from(container.children);
      children.sort((a, b) => {
        const aY = parseInt(a.dataset[dataAttr]);
        const bY = parseInt(b.dataset[dataAttr]);
        return this.sortOrder === 'desc' ? bY - aY : aY - bY;
      });
      children.forEach(c => container.appendChild(c));
    },
    showYear(el) {
      if (this.selectedYear === 'all') return true;
      return String(el.dataset[dataAttr]) === String(this.selectedYear);
    }
  };
}
